import {Injectable} from '@angular/core';
import {Firestore} from '@angular/fire/firestore';
import {AuthService} from '@shared/services/auth.service';
import {TransactionRule} from '../models/transactionRule.interface';
import {AbstractFirestoreModularService} from '@shared/services/abstracts/AbstractFirestoreModularService';


@Injectable()
export class TransactionsRulesModularService extends AbstractFirestoreModularService<TransactionRule> {

    COLLECTION = 'transactionsRules';

    constructor(authService: AuthService,
                firestore: Firestore) {
        super(authService, firestore);
    }


}
